// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {ScenarioGroup} from "@models";
import {SimMaterialDialogService, NotificationService, SimScenarioService} from "@services";
import {VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";
import {Translations} from "@translations";

@Component({
	selector: "sim-scenario-group-chip-input",
	templateUrl: "./sim-scenario-group-chip-input.component.html",
	styleUrls: ["./sim-scenario-group-chip-input.component.scss"],
	standalone: false,
})
export class SimScenarioGroupChipInputComponent {
	T = Translations;

	@Input() scenarioGroupFc: FormArray<FormControl<ScenarioGroup>>;
	@Input() label: string;
	@Input() placeholder: string;

	@Input() canSelectMultipleScenarioGroups = false;

	optionSelected = output<ScenarioGroup>();

	autoCompleteData: VMAutoCompleteNormal<ScenarioGroup>[] = [];

	private _availableScenarioGroups: ScenarioGroup[] = [];

	constructor(
		private _scenarioService: SimScenarioService,
		private _dialogService: SimMaterialDialogService,
		private _notificationService: NotificationService,
	) {
		this._scenarioService.getScenarioGroups().then((scenarioGroups) => {
			this._availableScenarioGroups = scenarioGroups;
			this.reloadAutoCompleteData("");
		});
	}

	reloadAutoCompleteData(searchString: string) {
		this.autoCompleteData = this._availableScenarioGroups
			.filter((g) => g.name.toLowerCase().includes(searchString.toLowerCase()))
			.map((g) => ({
				displayName: g.name,
				value: g,
			}));
	}

	async openCreateScenarioGroupDialog() {
		const result = await this._dialogService.openCreateByNameDialog({title: "Create Scenario Group"}).catch(() => {});

		if (result && result.action === "ok") {
			this._scenarioService
				.createScenarioGroup({name: result.newName})
				.then(() => {
					this._notificationService.notifySuccess("Scenario Group created");
					this._scenarioService.getScenarioGroups().then((scenarioGroups) => {
						this._availableScenarioGroups = scenarioGroups;
						this.reloadAutoCompleteData("");
					});
				})
				.catch(() => {
					this._notificationService.notifyError("Error creating Scenario Group");
				});
		}
	}
}
